import { ShapeLineConfig, TDynamicVariable } from "@shared/types";
import { CoreConfig } from "../types";
import { getComputedLines, getLength, roundNumber } from "../utils";

export const calculateLine = (
  variable: TDynamicVariable,
  config: CoreConfig & {
    appendUnit?: boolean;
  },
  debug = false
) => {
  // Get all lines and 3_POINT_CURVE shapes (getComputedLines now includes both)
  const allShapes = getComputedLines(config, variable.subtype, debug);
  
  switch (variable.output) {
    // @ts-ignore - Legacy Naming
    case "COUNT":
      return allShapes.length;
    case "SEGMENT":
      // Calculate total fence segments based on total length divided by post spacing
      const totalLength = allShapes.map((l) => getLength(l)).reduce((a, b) => a + b, 0);
      const postSpacing = config.linePostDistanceOnCenter || 10;
      
      // Handle edge cases
      if (totalLength <= 0 || postSpacing <= 0) {
        return 0;
      }
      
      // Calculate segments using Math.ceil(length / spacing) similar to line post calculation
      
      return Math.ceil(totalLength / postSpacing);
    case "EXISTS":
      return allShapes.length >= 1 ? 1 : 0;
    case "LENGTH":
      const length = roundNumber(
        allShapes.map((l) => getLength(l)).reduce((a, b) => a + b, 0),
        config
      );
      return config.appendUnit
        ? `${length}${config.defaultUnit || "ft"}`
        : length;
  }
};
